import React, {Component} from 'react'
import Header from "../components/header"
import Footer from "../components/footer"
import '../../static/css/style.scss'
import CardItem from "../components/cardItem"
class Newzealand extends Component {
	state={
		mingxiao:[
			{
				name:'奥克兰大学',
				content:'奥克兰大学是新西兰最好的研究中心，具备最广泛的博士研究领域。新西兰政府在对奥克兰大学的评估报告中总结道：“无论从哪一个角度讲，奥克兰大学在学术研究方面都是新西兰的佼佼者。',
				// zhuanye:['澳洲留学优势科目','法律','商科']
			},
			{
				name:'奥塔哥大学',
				content:'奥塔哥大学在生物科学、心理学、人类学、历史和艺术史、地质学、法律和哲学等专业领域具有独特优势。该校的医学院有很强的科研能力，在海内外颇负盛名。此外，该校创业园鼓励和发展科研成果的商业运用，尤其在生物科技和IT领域。',
				// zhuanye:['澳洲留学优势科目','MBA','医科','法律']
			},
			{
				name:'维多利亚大学',
				content:'惠灵顿维多利亚大学在法律、音乐、政治、管理、经济、政府研究、工商管理硕士、建筑及设计、地球科学、材料科学、心理学、电影及戏剧、语言学、信息管理及计算机科学、生物科学等领域成就卓著。',
				// zhuanye:['澳洲留学优势科目','工程','理科']
			},
			{
				name:'坎特伯雷大学',
				content:'坎特伯雷大学的工科课程是新西兰最完善的，也是世界闻名的。除工学院外，其商学院的建筑风格非常前卫，法学院的建筑则非常庄严。坎特伯雷大学坚持了这样的原则：大学教育旨在提高人们学识上的独立性和批判思维的能力。同时，它把现代学院同古老传统结合在一起。这些学院包括：艺术、贸易、工程设计、法学、音乐和美术，林业和科学。',
				// zhuanye:['澳洲留学优势科目','医学','法律','商科']
			},
			{
				name:'怀卡托大学',
				content:'新西兰全国研究排名中，怀卡托大学的以下科目在新西兰各大学排名：会计与金融、商业、传播学、新闻媒体学、音乐、文学艺术与其他艺术、化学、计算机科学、生态学、进化与行为、生物学、数学和教育。怀卡托大学被誉为南半球的“哈佛”。',
				// zhuanye:['澳洲留学优势科目','会计','生物科学','信息工程']
			},
			{
				name:'林肯大学',
				content:'林肯大学研究课题的一个总结性介绍。学校共有16个核心研究课题，涉及从动物研究、食品研究到生态学和旅游学的广泛领域。林肯大学在商业、管理、环境管理和旅游方面很强。',
				// zhuanye:['澳洲留学优势科目','工程','商科']
			},
			{
				name:'梅西大学',
				content:'在理论科学、应用科学（包括农业、园艺、兽医学）、商业、教育、社会科学、科技、工程和信息科学方面独具特长。该校阿兰威尔森分子生态与进化研究中心是政府资助的优秀研究中心之一，在分子进化速度、生物多样性等方面具有一定的权威性。',
				// zhuanye:['澳洲留学优势科目','医学','法律','建筑','教育']
			},
			{
				name:'奥克兰理工大学',
				content:'简称AUT，原名为奥克兰理工学院，2000年1月被新西兰政府正式授予国立大学的地位，被誉为新西兰最年轻、最有活力的大学，同时也是新西兰最大的理工类大学。奥克兰理工大学留学生分别来自52个国家。大学采取小班教学，平均每班16人，使每个学生都能得到很好的照顾。',
				// zhuanye:['澳洲留学优势科目','法律','医学','商科']
			}
		],
		zhuanye:[
			{
				name:'农业类专业',
				content:'新西兰的农业学科门类齐全，如农业技术、园艺科学、景观建筑设计、葡萄酒栽培和酿造、土地和物业管理等等。<br><br> 推荐院校林肯大学、怀卡托大学、梅西大学等。',
			},
			{
				name:'工程类专业',
				content:'新西兰的工程类专业分支很多，其中电子工程、通信工程、微电子技术等工程技术类专业一直是新西兰短缺移民类专业。<br><br> 推荐院校：坎特伯雷大学、奥克兰理工大学、奥克兰大学、怀卡托大学等。',
			},
			{
				name:'建筑专业',
				content:'在新西兰，建筑类专业是比较热门的专业之一，市场需求量比较大，就业也比较容易。一些有经验的建筑设计、施工管理人员、其年薪可以达到十万纽币以上或者更多，但入学要求相对较高。 <br><br> 推荐院校：奥克兰大学、坎特伯雷大学、维多利亚大学、惠灵顿理工学院等。',
			},
			{
				name:'教育类专业',
				content:'教育作为新西兰长期紧缺的职业，也是政府重点扶持的行业。开设教育专业的优秀学校很多，保证了极高的毕业率和就业率，而且移民也有的充分的保障。<br><br>推荐院校：奥克兰大学、梅西大学、Unitec理工学院等。',
			},
			{
				name:'会计专业',
				content:'会计专业为新西兰移民专业，学生注册会计师后即可申请移民。并且会计专业的毕业生就业范围很广，包括国企、外企、私企财会部门、金融机构等。<br><br>推荐院校：奥克兰理工大学、梅西大学、怀卡托大学等。',
			},
			{
				name:'护理专业',
				content:'护士属于新西兰的紧缺职业，且长期位于新西兰移民紧缺行业清单中；新西兰人口老龄化严重，护理专业已经成为新西兰最受重视的职业之一，一直被看作是对人类社会非常有贡献、回报又很高的职业，从事护理专业的人十分受尊敬。西方国家的护理人员需使用各种高新的医疗设备，配合医生对病人做出全面的诊断和看护。<br><br>推荐院校：梅西大学、Unitec、Ucol、Wintec等理工学院。',
			},
			{
				name:'酒店与旅游管理专业',
				content:'作为资源丰富的旅游国家，在新西兰学习酒店与管理专业的学生毕业后很好找工作，当地的酒店以及旅行社等机构也会为学生提供诸多的工作，另外在新西兰具有该专业的学生也很多，有更大的选择面，学生可以根据自身的情况申请留学目的地。<br><br>推荐院校：奥克兰理工大学、怀卡托大学、基督城理工学院、惠灵顿理工学院等。',
			},
			{
				name:'传媒专业',
				content:'新西兰传媒业的发展也是飞速的，新西兰八所国立大学大多设有传媒专业，还有一些私立大学也都设有传媒专业，这就给留学生提供了一个很好的选择空间，传媒专业的就业前景广泛，毕业生可选择在新闻媒体、传媒公司、文化公司、电台及电视台等行业工作。<br><br>推荐院校：奥克兰理工大学、维多利亚大学、坏卡托大学等。',
			}
		],
		list:[
			{
				title:'幼教专业',
				content:'近年来中国幼儿教育正在崛起的专业重要性；在新西兰幼儿教育无疑是新西兰最热门的专业移民。尤其从事此项职业的申请者，还有额外的移民加分。教师职业是新西兰稀缺的专业人才，这也是政府的重点扶持。每年国家对教师的需求都在上升。随着新西兰人口的不断增加，该专业毕业生在新西兰的就业率一直居高不下。它被新西兰移民市场公认为“最稳定的移民职业”。',
				img:require('../../static/images/zewzealand03.jpg')
			},
			{
				title:'工程专业',
				content:'新西兰工程专业在新西兰就业和移民非常具有优势，目前被新西兰工程师协会（简称IEAust）承认的工程师职业分类为三类：职业工程师、工程技师、助理工程师。当然了，根据所具体从事的专业，工程师又可分为众多学科，如医学工程、航空和航天工程、农业工程、建筑机械设备工程、化学工程、土木工程、电气工程、 海岸与海洋工程、环境工程、工业工程等。科学与工程专业的学生留学选择的空间还是挺大的。',
				img:require('../../static/images/zewzealand04.jpg')
			},
			{
				title:'计算机专业',
				content:'新西兰工程专业在新西兰就业和移民非常具有优势，目前被新西兰工程师协会（简称IEAust）承认的工程师职业分类为三类：职业工程师、工程技师、助理工程师。当然了，根据所具体从事的专业，工程师又可分为众多学科，如医学工程、航空和航天工程、农业工程、建筑机械设备工程、化学工程、土木工程、电气工程、 海岸与海洋工程、环境工程、工业工程等。科学与工程专业的学生留学选择的空间还是挺大的。',
				img:require('../../static/images/zewzealand05.jpg')
			},
			{
				title:'酒店管理专业',
				content:'新西兰依靠独特的地理位置和自然风光已成为世界著名的度假胜地，和游客的除了澳大利亚的主要来源，新西兰是一个中国人。新西兰酒店管理专业是新西兰497的热门专业之一。新西兰旅游业发展历史悠久，酒店管理体系非常成熟，当地酒店公司也为学生提供了很多实习机会。',
				img:require('../../static/images/zewzealand06.jpg')
			},
		]
	}
	render() {
		return (
			<div className={'page'}>
				<Header/>
				<div className={'main'}>
					<img className={'banimg'} src={require('../../static/images/zewzealand01.jpg')} alt=""/>
					<div className={'content'}>
						<div className={'title'}>
							<span>新西兰简介</span>
							<span className={'line'}/>
						</div>
						<div className={'contentModule'}>
							<div className={'text textJust'}>
								新西兰的教学体制比较灵活，留学生在留学期间，也可转签英国，加拿大，澳大利亚等英联邦国家继续深造，这就为留学生学习提供了极大的便利。新西兰的教育体制被视为世界上最好的教育体制之一，全国实行统一的教育体系，教育经费开支占政府开支第三位。
								同时，新西兰是世界上第一个宣布为无核的国家，并且在2009年被评为全世界最安全的国家之一。</div>
							<img className={'img'} src={require('../../static/images/zewzealand02.jpg')} alt=""/>
						</div>
						<div className={'title'}>
							<span>新西兰留学优势</span>
							<span className={'line'}/>
						</div>
						<div className={'textModule'}>
							<div className={'textModuleItem'}>
								<div className={'textModuleItemFlexWrap'}>
									<div className={'textModuleItemTitle'}>新西兰教育水平高</div>
									<div className={'textModuleItemText textJust'}>新西兰的教育体制承袭英国的优秀传统，加之富有创意的改革，被视为世界上最好的教育体制之一。新西兰高等学府拥有优秀的学术教育水平，曾先后培养出4位诺贝尔奖得主，许多专业居于世界领先地位，诸如生物技术、法医学、牙医、
										海洋工程、环境科学和园艺学等某些尖端领域。</div>
								</div>
							</div>
							<div className={'textModuleItem'}>
								<div className={'textModuleItemFlexWrap'}>
									<div className={'textModuleItemTitle'}>学历全球认可 学制灵活</div>
									<div className={'textModuleItemText textJust'}>专家指出，新西兰的学制非常灵活，在完成语言课程后，根据学生当时的个人情况，可以改变学习计划，专业可以任意转换，大学可以随意选择，也可转其他国家。就读专业课程期间也可转学，并减免学分。
										可根据学生学习和生活情况灵活掌握。</div>
								</div>
							</div>
							<div className={'textModuleItem'}>
								<div className={'textModuleItemFlexWrap'}>
									<div className={'textModuleItemTitle'}>学习、生活环境好</div>
									<div className={'textModuleItemText textJust'}>新西兰风景秀丽、气候温和，被世人誉为“世界上最后一片净土”，连续多年被联合国国家发展组织评定为“世界上最适于生活的国家”。英语是新西兰的官方和通用语言，课内课外，学生都是在良好的英语环境中学习。 <br/><br/>
										相对于其他西方发达国家，这里的中国人是最少的，你可以完全融入西方社会，了解西方人的思想、观念和生活方式，这也是学习专业课程之外最重要的知识。</div>
								</div>
							</div>
							<div className={'textModuleItem'}>
								<div className={'textModuleItemFlexWrap'}>
									<div className={'textModuleItemTitle'}>学费和生活费用低，担保资金少</div>
									<div className={'textModuleItemText textJust'}>目前，相对于其他英联邦发达国家，去新西兰留学的费用是最低的，大约15万人民币/年。
									</div>
								</div>
							</div>
							<div className={'textModuleItem'}>
								<div className={'textModuleItemFlexWrap'}>
									<div className={'textModuleItemTitle'}>无需雅思成绩，留学成本低，是最佳跳板</div>
									<div className={'textModuleItemText textJust'}>申请新西兰留学签证没有英语水平的入门要求，可以在新西兰读英语，比在国内节省2/3时间，有别于澳大利亚需要通过雅思或其他英语考试才能递交签证的要求。
										新西兰学生可直接升入英国、加拿大、澳大利亚等英联邦国家继续深造。</div>
								</div>
							</div>
							<div className={'textModuleItem'}>
								<div className={'textModuleItemFlexWrap'}>
									<div className={'textModuleItemTitle'}>合法打工</div>
									<div className={'textModuleItemText'}>留学生可以合法打工。每周20小时。打工工资可以支付在新西兰的生活费用。</div>
								</div>
							</div>
							<div className={'textModuleItem'}>
								<div className={'textModuleItemFlexWrap'}>
									<div className={'textModuleItemTitle'}>家属可陪读</div>
									<div className={'textModuleItemText textJust'}>1、就读紧缺行业、研究生、博士生课程的留学生，其配偶可到新西兰陪读并获得开放性的工作签证，可在陪读期间工作，并申请移民。子女上学享受与当地学生同等待遇。这些优惠政策在很多英语国家都是没有的。 <br/>
										2、18岁以下留学生的家属，可一同赴新陪读。</div>
								</div>
							</div>
							<div className={'textModuleItem'}>
								<div className={'textModuleItemFlexWrap'}>
									<div className={'textModuleItemTitle'}>申请移民快</div>
									<div className={'textModuleItemText textJust'}>
										移民政策宽松，留学生毕业后可自动获得工作签证，并可申请永久居留权。新西兰是移民最快的国家。在新西兰读完一个至少两年制的大专文凭或学位课程，就可以获得一个长度为1年的开放性签证，帮助国际学生在毕业后留在当地工作甚至是申请移民。华通留学留学专家指出，这一友好开放的举措极大降低了移民难度，在其他英语系国家的移民政策中也是少见的。即使你没能立即拿到开放性签证，毕业后也可凭雇主录用通知书，申请2-3年的工作签证。
									</div>
								</div>
							</div>
						</div>
						<div className={'title'}>
							<span>新西兰留学学校</span>
							<span className={'line'}/>
						</div>
						<div className={'mingxiao'}>
							{
								this.state.mingxiao.map((item,index)=>{
									return (
										<div className={'mingxiaoItem'} key={index}>
											<div className={'mingxiaoItemTitle line_wrap'}>
												<span className={'line_title'}>
													{item.name}
												</span>
											</div>
											<div className={'mingxiaoItemText'} dangerouslySetInnerHTML={{__html:item.content}}/>
											{/*<div className={'mingxiaoItemZhuanYe'}>*/}
											{/*	{*/}
											{/*		item.zhuanye.map((item,index)=>{*/}
											{/*				return <div className={['mingzhuanye',index===0?'on':null].join(' ')} key={index}>{item}</div>*/}
											{/*		})*/}
											{/*	}*/}
											{/*</div>*/}
										</div>
									)
								})
							}
						</div>
						<div className={'title'}>
							<span>就业好的专业</span>
							<span className={'line'}/>
						</div>
						<div className={'mingxiao'}>
							{
								this.state.zhuanye.map((item,index)=>{
									return (
										<div className={'mingxiaoItem'} key={index}>
											<div className={'mingxiaoItemTitle line_wrap color_orange'}>
												<span className={'line_title color_orange'}>
													{item.name}
												</span>
											</div>
											<div className={'mingxiaoItemText textJust'} dangerouslySetInnerHTML={{__html:item.content}}/>
										</div>
									)
								})
							}
						</div>
						<div className={'title'}>
							<span>移民快的专业</span>
							<span className={'line'}/>
						</div>
						<div className={'zhuanye'}>
							{
								this.state.list.map((item,index)=>(
									<CardItem item={item} key={index}/>
								))
							}
						</div>
					</div>
				</div>
				<Footer/>
			</div>
		)
	}
}

export default Newzealand